import React from "react";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 10,
        padding: '0 20px',
        gap: 5
    },
    label: {
        marginBottom: 2,
        font: 14,
        color: '#333',
        fontWeight: '600'
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'row',
        gap: 10
    },
    selector: {
        border: '1px solid #ccc',
        borderRadius: 5,
        padding: '7px 10px'
    },
    activeSelector: props => ({
        border: `2px solid ${props.options.buttonColor}`,
        borderRadius: 5,
        padding: '7px 10px',
        color: `${props.options.buttonColor}`,
        backgroundColor: `${props.options.buttonColor}` + '10'
    })
}));

export default function ProductVariantsArea({ colors }) {
    const classes = useStyles(colors);

    return (
        <div className={classes.root}>
            <p className={classes.label}>
                Cor:
            </p>

            <div className={classes.wrapper} >
                <div className={classes.activeSelector}>
                    Marrom
                </div>
                <div className={classes.selector}>
                    Preto
                </div>
                <div className={classes.selector}>
                    Branco
                </div>
            </div>
        </div>
    );
};